import React from 'react';
import { PropTypes } from 'prop-types';
import FlatButton from './FlatButton';

const Review = props => {
  const { edit, remove, list, submit } = props;

  return (
    <div className="scan-review">
      <div className="review-list">
        <div className="review-row head">
          <div className="review-index" />
          <div className="review-col">Part Number</div>
          <div className="review-col">Purchase Order</div>
          <div className="review-col center">Qty</div>
          <div className="review-col">Packing Slip</div>
        </div>

        {list.map((item, index) => {
          if (!item.done) {
            return null;
          }

          return (
            <div className="review-row data" key={`${item.part}${item.po}`}>
              <div className="review-index"><FlatButton title="Remove" onClick={() => remove(index)} className="remove" icon="close" /></div>
              <div className="review-col" onClick={() => edit(index, 0)}>{item.part}</div>
              <div className="review-col" onClick={() => edit(index, 1)}>{item.po}</div>
              <div className="review-col center" onClick={() => edit(index, 2)}>{item.qty}</div>
              <div className="review-col">{item.packingSlip}</div>
            </div>
          );
        })}

      </div>
      <FlatButton className="add-more" onClick={() => edit('last')}>Add More</FlatButton>
      <FlatButton className="primary" onClick={submit}>Submit</FlatButton>
    </div>
  );
};

Review.propTypes = {
  edit: PropTypes.func,
  remove: PropTypes.func,
  list: PropTypes.array,
  submit: PropTypes.func,
};

export default Review;
